export enum Thematic {
  ADMINISTRATION = 'Administration',
  SOCIAL_AFFAIRS = 'Affaires sociales',
  AGRICULTURE_RURAL = 'Agriculture & rural',
  ART_CULTURE = 'Art & Culture',
  COMMERCE = 'Commerce',
  COMMUNICATION = 'Communication',
  LOCAL_DEVELOPMENT = 'Développement Local',
  DEFENSE_SECURITY = 'Défense & Sécurité',
  LAND_URBAN_PLANNING = 'Foncier et Urbanisme',
  WATER_ENERGY = 'Eau & énergie',
  BASIC_EDUCATION = 'Éducation de base',
  LIVESTOCK_FISHING = 'Élevage & pêche',
  EMPLOYMENT_TRAINING = 'Emploi & formation',
  HIGHER_EDUCATION = 'Enseignement Supérieur',
  SECONDARY_EDUCATION = 'Enseignement Secondaire',
  SUSTAINABLE_DEVELOPMENT = 'Développement durable',
  WOMEN_FAMILY = 'Femme & famille',
  ECONOMY_FINANCE = 'Économie & Finances',
  FORESTS_WILDLIFE = 'Forêts & faune',
  YOUTH_CIVISM = 'Jeunesse & civisme',
  LAW_JUSTICE = 'Droit & Justice',
  PUBLIC_PROCUREMENT = 'Marchés publics',
  MINING_INDUSTRY = 'Mines & industrie',
  DIGITAL = 'Numérique',
  RESEARCH_INNOVATION = 'Recherche & innovation',
  PUBLIC_SERVICE = 'Fonction publique',
  FOREIGN_RELATIONS = 'Relations extérieures',
  HEALTH = 'Santé',
  SPORT = 'Sport',
  TRANSPORT_MOBILITY = 'Transport & mobilité',
  LABOR_SOCIAL_SECURITY = 'Travail & sécurité sociale',
  PUBLIC_WORKS = 'Travaux publics',
  CONSULTATION = 'Concertation',
  TRAINING = 'Formation',
  MAJOR_PROJECTS = 'Grand projets',
  INTERNATIONAL_SOLIDARITY = 'Solidarité internationale',
  OTHERS = 'autres',
}
